import React from 'react';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

function GSTReports() {
    const [formData, setFormData] = useState({
        saleGstList: [],
        purchaseGstList: [],
        search_key: '',
        from_date: new Date().toISOString().split('T')[0],
        to_date: new Date().toISOString().split('T')[0],
        activeTab: 'sale', // 'sale' or 'purchase'
        gst_filter: '' ,// '' = all
        hsn_filter: '',

    });

    const [filteredData, setFilteredData] = useState([]);

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");

        if (storedData) {
            const fd = new FormData();
            fd.append('from_date', formData.from_date);
            fd.append('to_date', formData.to_date);

            try {
                const response = await axios.post(
                    AppConst.BASE_URL + AppConst.getGstReportUrl, 
                    fd, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                
                if (response.data.status) {
                    setFormData(prev => ({
                        ...prev,
                        saleGstList: response.data.sale_records || [],
                        purchaseGstList: response.data.purchase_records || []
                    }));
                } else {
                    toast.error(response.data.message || "Failed to fetch GST data");
                }
            } catch (error) {
                console.error(error);
                toast.error("Error fetching GST reports");
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClearFilters = () => {
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            search_key: "",
            gst_filter: "",   // 👈 add if you also want these reset
hsn_filter: "",
            from_date: today,
            to_date: today,
        }));
    };

    const handleTabChange = (tab) => {
        setFormData(prev => ({
            ...prev,
            activeTab: tab,
            search_key: '' // Clear search when switching tabs
        }));
    };

    // Filter data based on search and active tab
    useEffect(() => {
        const currentList = formData.activeTab === 'sale' 
            ? formData.saleGstList 
            : formData.purchaseGstList;

        let result = currentList;

        // text search
        if (formData.search_key.trim() !== '') {
            const searchLower = formData.search_key.toLowerCase();
            result = result.filter(item => 
                item.medicine_name?.toLowerCase().includes(searchLower) ||
                item.supplier_name?.toLowerCase().includes(searchLower) ||
               item.batch_no?.toLowerCase().includes(searchLower) ||
        item.hsn_no?.toLowerCase().includes(searchLower)   // 👈 add
            );
        }

        // GST % filter
        if (formData.gst_filter !== '') {
            result = result.filter(item =>
                parseFloat(item.gst_percent || 0).toFixed(2) === formData.gst_filter
            );
        }

        if (formData.hsn_filter !== '') {
    result = result.filter(item => (item.hsn_no || '') === formData.hsn_filter);
}

        setFilteredData(result);
    }, [formData.search_key, formData.gst_filter, formData.hsn_filter,formData.saleGstList, formData.purchaseGstList, formData.activeTab]);

    useEffect(() => {
        initData();
    }, []);

    // Auto-reload when dates change
    useEffect(() => {
        if (formData.from_date && formData.to_date) {
            initData();
        }
    }, [formData.from_date, formData.to_date]);

    // Calculate totals
    const calculateTotals = () => {
        let totalGst = 0;
        let totalMrp = 0;

        filteredData.forEach(item => {
            const qty = parseFloat(item.qty || 0);
            totalGst += parseFloat(item.gst_amount || 0);
            totalMrp += parseFloat(item.mrp || 0) * qty;   // × qty
        });

        return { totalGst, totalMrp };
    };


// Group by GST % → count, total amount, total GST
// Group by GST % → total qty, total amount, total GST
const gstBreakdown = () => {
    const groups = {};
    filteredData.forEach(item => {
        const pct = parseFloat(item.gst_percent || 0).toFixed(2);
        const hsn = item.hsn_no || '-';
        const key = `${pct}||${hsn}`;
        const qty = parseFloat(item.qty || 0);
        if (!groups[key]) {
            groups[key] = { gst_percent: pct, hsn_no: hsn, count: 0, total: 0, gst: 0 };
        }
        groups[key].count += qty;
        groups[key].total += parseFloat(item.mrp || 0) * qty;
        groups[key].gst   += parseFloat(item.gst_amount || 0);
    });
    return Object.values(groups).sort((a, b) => {
        const d = parseFloat(a.gst_percent) - parseFloat(b.gst_percent);
        return d !== 0 ? d : String(a.hsn_no).localeCompare(String(b.hsn_no));
    });
};

const breakdown = gstBreakdown();

    const totals = calculateTotals();



    // distinct GST %s present in the current list (for the dropdown)
    const currentListForFilter = formData.activeTab === 'sale'
        ? formData.saleGstList
        : formData.purchaseGstList;

    const gstOptions = [...new Set(
        currentListForFilter.map(i => parseFloat(i.gst_percent || 0).toFixed(2))
    )].sort((a, b) => parseFloat(a) - parseFloat(b));
    const hsnOptions = [...new Set(
    currentListForFilter.map(i => i.hsn_no).filter(Boolean)
)].sort();
    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF('l', 'mm', 'a4');
        
        const reportType = formData.activeTab === 'sale' ? 'Sale GST Report' : 'Purchase GST Report';
        
        // Add title
        doc.setFontSize(18);
        doc.text(reportType, 14, 15);
        
        // Add date range
        doc.setFontSize(10);
        doc.text(`Date Range: ${formData.from_date} to ${formData.to_date}`, 14, 22);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 27);
        
        // Prepare table data
       const tableData = filteredData.map((item, index) => [
    index + 1,
    formData.activeTab === 'sale' ? (item.bill_no || '-') : '-',
    formData.activeTab === 'sale' ? (item.med_bill_ipd_number || '-') : '-',
    item.medicine_name || '-',
    item.hsn_no || '-',   // 👈 add
    item.supplier_name || '-',
    `${parseFloat(item.mrp || 0).toFixed(2)}`,
    `${parseFloat(item.gst_amount || 0).toFixed(2)}`
]);

        // Add table
        autoTable(doc, {
            //head: [['Sl No', 'Medicine Name', formData.activeTab === 'sale' ? 'Customer Name' : 'Supplier Name', 'MRP', 'GST Amount']],
            
            head: [[
                'Sl No',
                'Bill No',
                'UHID No',
                'Medicine Name',
                  'HSN', 
                formData.activeTab === 'sale' ? 'Customer Name' : 'Supplier Name',
                'MRP',
                'GST Amount'
            ]],
            body: tableData,
            startY: 32,
            theme: 'striped',
            headStyles: { fillColor: [64, 81, 137], textColor: 255, fontSize: 9 },
            bodyStyles: { fontSize: 8 },
            alternateRowStyles: { fillColor: [245, 245, 245] },
           columnStyles: {
    0: { cellWidth: 12 },
    1: { cellWidth: 20 },
    2: { cellWidth: 30 },
    3: { cellWidth: 55 },
    4: { cellWidth: 25 },                       // HSN
    5: { cellWidth: 50 },
    6: { cellWidth: 28, halign: 'right' },
    7: { cellWidth: 28, halign: 'right' }
},
foot: [[
    'Total', '', '', '', '', '',
    `${totals.totalMrp.toFixed(2)}`,
    `${totals.totalGst.toFixed(2)}`
]],
            footStyles: {
                fillColor: [64, 81, 137],
                textColor: 255,
                fontStyle: 'bold',
                halign: 'right'
            }
        });


        // ---------- GST %-wise Summary table ----------
      const summaryBody = breakdown.map(g => [
    `${g.gst_percent}%`,
    g.hsn_no,              // 👈 add
    g.count,
    `${g.total.toFixed(2)}`,
    `${g.gst.toFixed(2)}`
]);
        const summaryStartY = doc.lastAutoTable.finalY + 10;

        doc.setFontSize(12);
        doc.text('GST %-wise Summary', 14, summaryStartY - 2);

        autoTable(doc, {
           head: [['GST %', 'HSN', 'Items', 'Total MRP', 'Total GST']],
body: summaryBody,
startY: summaryStartY + 2,
theme: 'grid',
headStyles: { fillColor: [64, 81, 137], textColor: 255, fontSize: 9 },
bodyStyles: { fontSize: 8 },
columnStyles: {
    0: { cellWidth: 25 },
    1: { cellWidth: 35 },                       // HSN
    2: { cellWidth: 25, halign: 'center' },
    3: { cellWidth: 40, halign: 'right' },
    4: { cellWidth: 40, halign: 'right' }
},
foot: [[
    'Total',
    '',
    breakdown.reduce((s, g) => s + g.count, 0),
    `${totals.totalMrp.toFixed(2)}`,
    `${totals.totalGst.toFixed(2)}`
]],
            footStyles: {
                fillColor: [64, 81, 137],
                textColor: 255,
                fontStyle: 'bold'
            }
        });

        // Add footer
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(
                `Page ${i} of ${pageCount}`,
                doc.internal.pageSize.getWidth() / 2,
                doc.internal.pageSize.getHeight() - 10,
                { align: 'center' }
            );
        }

        const fileName = formData.activeTab === 'sale' 
            ? `Sale_GST_Report_${formData.from_date}_to_${formData.to_date}.pdf`
            : `Purchase_GST_Report_${formData.from_date}_to_${formData.to_date}.pdf`;

        doc.save(fileName);
        toast.success("PDF exported successfully!");
    };

    // DataTable Columns
    const columns = [
        {
            name: 'Sl No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
            center: true
        },

        {
            name: 'Bill No',
            selector: row => row.bill_no || '-',
            sortable: true,
            width: '110px',
            center: true
        },
        {
            name: 'UHID No',
            selector: row => row.med_bill_ipd_number || '-',
            sortable: true,
            width: '150px',
            wrap: true
        },
        {
            name: 'Medicine Name',
            selector: row => row.medicine_name,
            sortable: true,
            grow: 3,
            wrap: true
        },
        {
    name: 'HSN No',
    selector: row => row.hsn_no || '-',
    sortable: true,
    width: '110px',
    center: true
},
        {
            name: formData.activeTab === 'sale' ? 'Customer Name' : 'Supplier Name',
            selector: row =>
                formData.activeTab === 'sale'
                    ? row.supplier_name || row.party_name || '-'   // SALE
                    : row.supplier_name || row.party_name || '-', // PURCHASE
            sortable: true,
            grow: 2,
            wrap: true
        },
        
        {
            name: 'MRP',
            selector: row => row.mrp,
            sortable: true,
            width: '120px',
            right: true,
            cell: row => `₹${parseFloat(row.mrp || 0).toFixed(2)}`
        },

        {
            name: 'Qty',
            selector: row => row.qty,
            sortable: true,
            width: '90px',
            center: true,
            cell: row => parseInt(row.qty || 0)
        },
        {
            name: 'GST %',
            selector: row => row.gst_percent,
            sortable: true,
            width: '130px',
            right: true,
            
        },
        {
            name: 'GST Amount',
            selector: row => row.gst_amount,
            sortable: true,
            width: '130px',
            right: true,
            cell: row => (
                <span className="badge bg-success-subtle text-success fs-6">
                    ₹{parseFloat(row.gst_amount || 0).toFixed(2)}
                </span>
            )
        }
    ];

    // Custom styles for DataTable
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#405189',
                color: '#fff',
                fontSize: '14px',
                fontWeight: 'bold',
                borderRadius: '5px 5px 0 0'
            }
        },
        headCells: {
            style: {
                color: '#fff',
                paddingLeft: '16px',
                paddingRight: '16px'
            }
        },
        rows: {
            style: {
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                }
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">
                                            <i className="ri-file-chart-line me-2"></i>
                                            GST Reports
                                        </h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <button 
                                            type="button" 
                                            className="btn btn-danger"
                                            onClick={exportToPDF}
                                            disabled={filteredData.length === 0}
                                        >
                                            <i className="ri-file-pdf-line align-bottom me-1"></i> 
                                            Export PDF
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Tab Buttons */}
                            <div className="card-body border-bottom">
                                <div className="btn-group w-100" role="group">
                                    <button
                                        type="button"
                                        className={`btn ${formData.activeTab === 'sale' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleTabChange('sale')}
                                    >
                                        <i className="ri-shopping-cart-line me-1"></i>
                                        Sale GST
                                        <span className="badge bg-light text-dark ms-2">
                                            {formData.saleGstList.length}
                                        </span>
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${formData.activeTab === 'purchase' ? 'btn-success' : 'btn-outline-success'}`}
                                        onClick={() => handleTabChange('purchase')}
                                    >
                                        <i className="ri-shopping-bag-line me-1"></i>
                                        Purchase GST
                                        <span className="badge bg-light text-dark ms-2">
                                            {formData.purchaseGstList.length}
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <label className="form-label">From Date</label>
                                        <input 
                                            className="form-control" 
                                            type="date" 
                                            name="from_date"
                                            onChange={handleChange} 
                                            value={formData.from_date} 
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">To Date</label>
                                        <input 
                                            className="form-control" 
                                            type="date" 
                                            name="to_date"
                                            onChange={handleChange} 
                                            value={formData.to_date} 
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label">&nbsp;</label>
                                        <div>
                                            <button 
                                                type="button" 
                                                onClick={handleClearFilters} 
                                                className="btn btn-info w-100"
                                            >
                                                <i className="ri-refresh-line me-1"></i> Clear
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label">GST %</label>
                                        <select
                                            className="form-select"
                                            name="gst_filter"
                                            onChange={handleChange}
                                            value={formData.gst_filter}
                                        >
                                            <option value="">All GST %</option>
                                            {gstOptions.map((g, i) => (
                                                <option key={i} value={g}>{g}%</option>
                                            ))}
                                        </select>
                                    </div>


                                    <div className="col-md-2">
                                        <label className="form-label">Search</label>
                                        <input 
                                            className="form-control" 
                                            placeholder="Search by Medicine, Supplier or Batch..." 
                                            type="text"
                                            name="search_key" 
                                            onChange={handleChange} 
                                            value={formData.search_key} 
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="card-body pt-0">
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    customStyles={customStyles}
                                    pagination
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100, 200]}
                                    highlightOnHover
                                    responsive
                                    striped
                                    dense
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-inbox-line fs-1 text-muted"></i>
                                            <p className="mt-3">
                                                No {formData.activeTab === 'sale' ? 'sale' : 'purchase'} GST records found
                                            </p>
                                        </div>
                                    }
                                />

<div className="mt-3 p-3 bg-light rounded">
                                    <h6 className="mb-3">GST %-wise Summary</h6>
                                    <table className="table table-sm table-bordered mb-0">
                                       <thead>
    <tr className="table-primary">
        <th>GST %</th>
        <th>HSN</th>{/* 👈 add */}
        <th className="text-center">Items</th>
        <th className="text-end">Total MRP</th>
        <th className="text-end">Total GST</th>
    </tr>
</thead>
<tbody>
    {breakdown.length === 0 ? (
        <tr><td colSpan="5" className="text-center">No data</td></tr>
    ) : (
        breakdown.map((g, i) => (
            <tr key={i}>
                <td>{g.gst_percent}%</td>
                <td>{g.hsn_no}</td>{/* 👈 add */}
                <td className="text-center">{g.count}</td>
                <td className="text-end">₹{g.total.toFixed(2)}</td>
                <td className="text-end">₹{g.gst.toFixed(2)}</td>
            </tr>
        ))
    )}
</tbody>
                                    </table>
                                </div>
                                
                                <div className="mt-3 p-3 bg-light rounded">
                                    <div className="row text-center">
                                        <div className="col-md-4">
                                            <strong>Total Records:</strong>
                                            <div className="fs-5 text-primary">{filteredData.length}</div>
                                        </div>
                                        <div className="col-md-4">
                                            <strong>Total MRP:</strong>
                                            <div className="fs-5 text-info">₹ {totals.totalMrp.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-4">
                                            <strong>Total GST Amount:</strong>
                                            <div className="fs-5 text-success">₹ {totals.totalGst.toFixed(2)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GSTReports;